<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <RealTimeOnline></RealTimeOnline>
      </v-col>
      <v-col cols="12" sm="12" class="mb-6 text-center">
        <h3 class="subtitle-2">
          - Statistics for the last month -
        </h3>
      </v-col>
      <v-col cols="12" sm="12" class="mb-5">
        <VisitInfo :visitInfo="visitInfo"></VisitInfo>
      </v-col>
      <v-col cols="12" sm="12" lg="6" class="mb-4">
        <VisitCountryMap :countryData="countryData"></VisitCountryMap>
      </v-col>
      <v-col cols="12" sm="12" lg="6" class="mb-4">
        <ContentTop5 :top5="top5"></ContentTop5>
      </v-col>
      <v-col cols="12" sm="12" lg="6" class="mb-4">
        <TheBrowserStats
          :browserRate="browserRate"
          :total="total"
        ></TheBrowserStats>
      </v-col>
      <v-col cols="12" sm="12" lg="6">
        <TheOurVisitors :deviceRate="deviceRate"></TheOurVisitors>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment-timezone";
export default {
  name: "Dashboards",
  data: () => ({
    page: {
      title: "Dashboards"
    },
    elementVisible: false,
    breadcrumbs: [
      {
        text: "Dashboards",
        disabled: true
      }
    ],
    total: 0,
    browserRate: null,
    deviceRate: null,
    visitInfo: null,
    countryData: null,
    top5: null
  }),
  components: {
    VisitInfo: () => import("@/views/dashboards/dashboardComponents/VisitInfo"),
    RealTimeOnline: () =>
      import("@/views/dashboards/dashboardComponents/RealTimeOnline"),
    ContentTop5: () =>
      import("@/views/dashboards/dashboardComponents/ContentTop5"),
    VisitCountryMap: () =>
      import("@/views/dashboards/dashboardComponents/VisitCountryMap"),
    TheBrowserStats: () =>
      import(
        "@/views/dashboards/dashboardComponents/browser-stats/TheBrowserStats"
      ),

    TheOurVisitors: () =>
      import(
        "@/views/dashboards/dashboardComponents/our-visitors/TheOurVisitors"
      )
  },
  async mounted() {
    await this.getChannelChartData();
    // 서버에 살아 있음을 알림
    await this.$store.dispatch("online");
  },
  methods: {
    async getChannelChartData(startTime, endTime) {
      const channel_id = this.$store.state.channelId;
      const start = Math.floor(
        moment()
          .subtract(1, "months")
          .valueOf() / 1000
      );
      const end = endTime ? endTime : Math.floor(Date.now() / 1000 + 600);

      const path = `/admin/getChannelChartData?channel_id=${channel_id}&start=${start}&end=${end}`;
      try {
        const data = await this.$axiosAuth.get(path);
        if (data && data.status == 200) {
          const result = data.data;
          this.browserRate = result.browserRate;
          this.deviceRate = result.deviceRate;
          this.countryData = result.countryData;
          this.total = result.visitorsCount;
          this.visitInfo = {};
          this.visitInfo.netVisitorsCount = result.netVisitorsCount;
          this.visitInfo.visitorsCount = result.visitorsCount;
          this.visitInfo.spentTime = result.spentTime;
          this.visitInfo.averageSpentTime = result.averageSpentTime;
          this.top5 = result.top5;
          console.log("====", { result });
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
